/**
 * The rótulo as the ERP will print it (#438).
 *
 * Drawn as a label rather than as a list: monospace, because the template is
 * laid out in fixed columns and a proportional font would reflow what the
 * patient will actually read, and on a white card with the edge of a sticker,
 * so the conferente sees the thing she is conferring rather than a summary of
 * it. The lines are the label's own, layout fields stripped and nothing else
 * changed.
 */
export function LabelPrint({ lines }: { lines: readonly string[] }) {
  return (
    <figure
      aria-label="Rótulo impresso"
      className="m-0 overflow-x-auto rounded-[6px] px-4 py-3"
      style={{
        backgroundColor: 'var(--color-fill-white)',
        border: '1px solid var(--color-stroke-strong)',
        boxShadow: '0 1px 2px rgba(0, 13, 77, 0.08)',
      }}
    >
      <pre className="text-tSmall text-text-strong m-0 font-mono leading-[1.5] whitespace-pre">
        {lines.join('\n')}
      </pre>
    </figure>
  )
}

/**
 * The rótulo inside its formula's step: after the card, whose last
 * comparison is the volume, and before the ficha de produção (#438).
 *
 * Shown, not compared. The conferente reads the printed label against the
 * receita by eye; nothing on it is scored, so it carries no colour and no
 * decision. Open from the start, unlike the ficha, because looking at it is
 * part of conferring the pote rather than reference for the bench.
 *
 * Nothing at all where the ERP had no label for this pote, or on a
 * conferência read before labels were.
 */
export function LabelPanel({ lines }: { lines: readonly string[] | undefined }) {
  if (lines === undefined || lines.length === 0) return null
  return (
    <details open className="border-stroke-weak mt-4 rounded-base border px-4 py-3">
      <summary className="text-tSmall text-text-weak cursor-pointer select-none">Rótulo</summary>
      <div className="mt-2">
        <LabelPrint lines={lines} />
      </div>
    </details>
  )
}
